/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Memberssearch1Inputs */

const en_memberssearch1 = /** @type {(inputs: Memberssearch1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search members`)
};

const de_memberssearch1 = /** @type {(inputs: Memberssearch1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitglieder suchen`)
};

/**
* | output |
* | --- |
* | "Search members" |
*
* @param {Memberssearch1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const memberssearch1 = /** @type {((inputs?: Memberssearch1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Memberssearch1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_memberssearch1(inputs)
	return de_memberssearch1(inputs)
});
export { memberssearch1 as "membersSearch" }